import Router from 'vue-router';
import { getRouteQueryParam } from './routeQuery';

/**
 * Read route query params from Vue Router 4's currentRoute ref (with fallback for test mocks).
 */
export function getReturnPathFromQuery(router: Router): string | undefined {
  const query = (router.currentRoute.value ?? router.currentRoute).query;
  return getRouteQueryParam(query, 'return_path') ?? getRouteQueryParam(query, 'returnPath') ?? undefined;
}

/**
 * Check if a return path is invalid (dashboard, login, or onboarding pages).
 * These paths should not be used as return paths to avoid redirect loops.
 */
export function isInvalidReturnPath(path: string | null | undefined): boolean {
  if (!path) return true;
  const normalizedPath = path.split('?')[0];
  return /^\/(account\/(seekers|providers)\/dashboard|login|sitter\/(signup|verify_identity|background_check|complete)|corporate-onboarding)/.test(
    normalizedPath
  );
}

/**
 * Navigate to the return_path from query params, or to the default path if return_path
 * is missing or invalid. Handles both relative paths and full URLs by extracting the path from URLs.
 */
export function navigateToReturnPath(router: Router, defaultPath: string): void {
  const returnPath = getReturnPathFromQuery(router);
  let normalizedReturnPath = returnPath;

  if (returnPath) {
    try {
      normalizedReturnPath = decodeURIComponent(returnPath);
    } catch {
      normalizedReturnPath = returnPath;
    }
  }

  if (normalizedReturnPath && !isInvalidReturnPath(normalizedReturnPath)) {
    let pathToNavigate = normalizedReturnPath;

    try {
      const url = new URL(normalizedReturnPath);
      pathToNavigate = url.pathname + url.search;
    } catch {
      pathToNavigate = normalizedReturnPath;
    }

    router.push(pathToNavigate);
  } else {
    router.push(defaultPath);
  }
}
